import { FIELD_TYPES } from "@hyro-components/fields/utils";

export const hasExpressionFieldsAtDepth = (field) => {
  if (!field || field.type !== FIELD_TYPES.OBJECT) return false;

  const fieldsArray = field.fields || [];
  if (fieldsArray.length > 0 && fieldsArray.every((f) => f.type === FIELD_TYPES.EXPRESSION)) {
    return true;
  }

  return fieldsArray.some((child) => {
    if (child.type === FIELD_TYPES.OBJECT) {
      return hasExpressionFieldsAtDepth(child);
    }

    if (child.type === FIELD_TYPES.CHOOSE_ONE) {
      const options = child.options || [];
      return options.length > 0 && options.every((option) => hasExpressionFieldsAtDepth(option));
    }

    return false;
  });
};
